import Flickity from 'flickity';

const initFlickity = (els) => {
    els.forEach(el => {
        const flickityOptions = {
            cellAlign: 'left',
            wrapAround: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            lazyLoad: true,
            imagesLoaded: true,
            watchCSS: true
        };

        const carousel = new Flickity(el, flickityOptions);
    })
}

export default initFlickity;